import React from "react";
import styled from "styled-components";

import {Icon,IconButton} from "@blueprint/ui";

type PendingFileRowProps = {
    name: string;
    onRemove: () => void;
    disabled: boolean;
};

const PendingFileRow = ({
    name,
    onRemove,
    disabled,
}: PendingFileRowProps): JSX.Element => {
    return (
        <Container
            className={`d-flex align-items-center bg-white px-2 mb-2 ${
                disabled ? "text-placeholder-grey" : ""
            }`}
        >
            <Icon className="flex-shrink-0" titleAccess={'Document'} margin="0" key={'Document'} name={'Document'} />
            {/*<FileIcon className="flex-shrink-0 icon-small text-placeholder-grey" />*/}
            <FileName className="flex-grow-1 mb-0 mx-2">{name}</FileName>

            <IconButton
                icon="Delete"
                variant="light.tertiary"
                size="small"
                onClick={onRemove}
                disabled={disabled}
            />
        </Container>
    );
};

const Container = styled.div`
    padding-top: 6px;
    padding-bottom: 6px;
    
`;

const FileName = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export default PendingFileRow;
